import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

// Arunika means the glow of sunrise: a rising sun over the horizon
export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' className={cn('size-8 shrink-0', className)} aria-hidden='true'>
            <rect width='64' height='64' rx='16' className='fill-brand' />
            <path d='M18 38a14 14 0 0 1 28 0Z' fill='#FFF6EC' />
            <rect x='12' y='41' width='40' height='4' rx='2' fill='#FFF6EC' />
            <rect x='21' y='48' width='22' height='4' rx='2' fill='#FFF6EC' fillOpacity='0.65' />
        </svg>
    )
}
